exports.APIS = {
  Auth: "/common/auth/admin-login",
  ChangePassword: "/common/auth/change-password",

  Location: {
    Country: "/admin/location/country",
    State: "/admin/location/state",
    District: "/admin/location/district",
    Taluka: "/admin/location/taluka",
    Area: "/admin/location/area",
    City: "/admin/location/city",
    Pincode: "/admin/location/pincode",
  },

  UserManagement: {
    Roles: "/admin/user-management/role",
    Users: "/admin/user-management/customer",
    Broker: "/admin/user-management/broker",
    Expert: "/admin/user-management/expert",
    Rental: "/admin/user-management/rental",
  },

  Masters: {
    AppSetUp: "/admin/master/app-setup",
    Purpose: "/admin/master/purpose",
    Category: "/admin/master/category",
    PropertyType: "/admin/master/property-type",
    FurnishType: "/admin/master/furnish-type",
    BHK: "/admin/master/bhk-type",
    Facing: "/admin/master/facing",
    Availability: "/admin/master/availability",
    Key_Heighlight: "/admin/master/key-highlights",
    Possession: "/admin/master/possession",
    Amenities: "/admin/master/amenities",
    Work_Start: "/admin/master/work-start",
    AreaIn: "/admin/master/area-in",
    Parking: "/admin/master/parking",
  },

  Subscription: {
    Subscription_Validity: "/admin/subscription/subscription-validity",
    Subscription_Features: "/admin/subscription/subscription-features",
    Subscription: "/admin/subscription/subscription",
  },

  Property: {
    Get_Property: "/admin/property/get-property",
    Subscription_Features: "/admin/subscription/subscription-features",
    Subscription: "/admin/subscription/subscription",
    Get_Property_Inquiry: "/admin/property/property-inquiry",
  },

  //FAQ
  Faqs: {
    FAQ: "/admin/faqs/faq",
    FAQCategory: "/admin/faqs/faqcategory",
  },

  //Blogs
  Blogs: {
    PopularTag: "/admin/blogs/populartag",
    Blog: "/admin/blogs/blog",
  },

  //Services
  Services: {
    ServiceInclude: "/admin/services/serviceinclude",
    KeyBenefit: "/admin/services/keybenefit",
    BestFor: "/admin/services/bestfor",
    Service: "/admin/services/service",
  },

  //AboutUs
  Aboutus: {
    Banner: "/admin/aboutus/banner",
    VisionMission: "/admin/aboutus/visionmission",
    WhyChooseUs: "/admin/aboutus/whychooseus",
    PeopleBehindWork: "/admin/aboutus/peoplebehindwork",
    WhyWeRank: "/admin/aboutus/whywerank",
    WhatMakeDifferent: "/admin/aboutus/whatmakedifferent",
    WeFocus: "/admin/aboutus/wefocus",
    WhatOurCustomerSay: "/admin/aboutus/whatourcustomersay",
    ManBehindPower: "/admin/aboutus/manbehindpower",
  },

  //Customizations
  Customizations: {
    AppSetup: "/admin/customizations/appsetup",
  },

  //SubsidyPolicys
  SubsidyPolicys: {
    SubsidyBanner: "/admin/subsidypolicys/subsidybanner",
    NewUpdate: "/admin/subsidypolicys/newupdate",
    SubsidyBenefit: "/admin/subsidypolicys/subsidybenefit",
    SubsidyRegistrationProcess:
      "/admin/subsidypolicys/subsidyregistrationprocess",
    LatestAnnouncement: "/admin/subsidypolicys/latestannouncement",
    Electricity: "/admin/subsidypolicys/electricity",
    RooftopSolar: "/admin/subsidypolicys/rooftopsolar",
  },

  //PrivacyPolicys
  PrivacyPolicys: {
    PrivacyPolicy: "/admin/privacypolicys/privacypolicy",
  },

  //Terms of service
  TermsOfServices: {
    TermsOfService: "/admin/termsofservices/termsofservice",
  },

  //Home page
  HomePage: {
    HomeBanner: "/admin/homepage/homebanner",
    EverySpace: "/admin/homepage/everyspace",
  },

  ContactUs: {
    Contact_Us: "/admin/contact/contact_us",
  },

  FreeConsultations: {
    FreeConsultation: "/admin/freeconsultations/freeconsultation",
  },

  //Gallerys
  Gallerys: {
    Gallery: "/admin/gallerys/gallery",
  },

  //common
  Commons: {
    AllCountry: "/common/masters/all-country",
    AllState: "/common/masters/all-state",
    AllDistrict: "/common/masters/all-district",
    AllTaluka: "/common/masters/all-taluka",
    AllArea: "/common/masters/all-area",
    AllPurposeRoles: "/common/masters/all-purpose-roles",
    AllExpertPurpose: "/common/masters/all-expert-purpose",
    AllBuilderPurpose: "/common/masters/all-builder-purpose",
    AllUserStatus: "/common/masters/all-user-status",
    AllSubscriptionFeatures: "/common/masters/all-subscription-features",
    AllSubscriptionValidity: "/common/masters/all-subscription-validity",
    AllLoginRoles: "/common/masters/all-login-roles",
    AllPropertyStatus: "/common/masters/all-property-status",
    // AllPropertyType: "/common/masters/all-property-type",
    AllPostedBy: "/common/masters/all-posted-by",
    AllPermmission: "/common/masters/all-permission",
    AllPropertyType: "/common/masters/all-property-type",
    AllPostedBy: "/common/masters/all-posted-by",
    AllBHK: "/common/masters/all-bhk",
    AllFurnishType: "/common/masters/all-furnish-type",
    AllFacing: "/common/masters/all-facing",
    AllAvailability: "/common/masters/all-availability",
    AllAminities: "/common/masters/all-aminities",
    AllKeyHighlight: "/common/masters/all-key-highlight",
    allWorkStart: "/common/masters/all-work-start",
    allStates: "/common/masters/all-states",
    AllCity: "/common/masters/all-city",
    AllPincode: "/common/masters/all-pincode",
  },

  // Dashboard
  Dashboard: {
    dashboard: "/admin/dashboard/totalservices",
  },

  Expert: {
    Get_Inquiry: "/admin/expert/expert-inquiries",
  },

  AboutUs: {
    AboutUsDetails: "/admin/about-us/about-us-details",
    OurStory: "/admin/about-us/our-story",
    Why_Choose_Us: "/admin/about-us/why-choose-us",
    Our_Platform_Work: "/admin/about-us/our-platform-work",
    Our_Users_Say: "/admin/about-us/our-users-says",
    Privacy_and_Policy: "/admin/about-us/privacy-policy",
    Terms_and_Conditions: "/admin/about-us/term-condition",
    Social_Link: "/admin/about-us/social-link",
  },

  Customization: {
    AppSetUp: "/admin/customization/app_setup",
  },

  Dashboard: {
    dashboard: "/admin/dashboard/dashboard-data",
  },

  Rating_Review: {
    Get_Rating: "/admin/ratingreview/get-rating",
  },
  Leads: {
    Get_Property_Leads: "/admin/leads/property-leads",
    Get_Expert_Leads: "/admin/leads/expert-leads",
  },

  AddProperty: {
    Status: "/admin/rental/rental-property",
    GetPersonalProperty:
      "/admin/rental/rental-property/get-personal-rental-property",
    StepOnePost: "/admin/rental/rental-property/add-property-step-one-post",
    StepOneGet: "/admin/rental/rental-property/get-step-one",

    StepTwoPost: "/admin/rental/rental-property/add-property-step-two-post",
    StepTwoGet: "/admin/rental/rental-property/get-step-two",

    StepThreePost: "/admin/rental/rental-property/add-property-step-three-post",
    StepThreeGet: "/admin/rental/rental-property/get-step-three",

    StepFourPost: "/admin/rental/rental-property/add-property-step-four-post",
    StepFourGet: "/admin/rental/rental-property/get-step-four",
    StepFourDeleteImage: "/admin/rental/rental-property/image-delete",

    StepFivePost: "/admin/rental/rental-property/add-property-step-five-post",
    StepFiveGet: "/admin/rental/rental-property/get-step-five",

    StepSixPost: "/admin/rental/rental-property/add-property-step-six-post",
    StepSixGet: "/admin/rental/rental-property/get-step-six",

    StepSevenPost: "/admin/rental/rental-property/add-property-step-seven-post",
    StepSevenGet: "/admin/rental/rental-property/get-step-seven",
  },

  RentalProperty: {
    GetRentalInquiry: "/admin/rental/get-rental-property",
  },
};
